import React, { useRef } from 'react';
import { PropTypes } from 'prop-types';
import ReactTooltip from 'react-tooltip';
import ThreeDotIcon from '@icons/ThreeDotIcon';
import { SettingsButtonStyled } from './InboxConversationItemStyled';
import { ButtonNoStyles } from '@styled';

const SettingsButton = ({ conversation }) => {
    const clickOutsideRef = useRef(null);
    const tooltipRef = useRef(null);
    const tooltipID = `tooltip-settings-${conversation.sid}`;

    const closeTooltip = () => {
        ReactTooltip.hide();
        ReactTooltip.hide(tooltipRef);
        tooltipRef.current.tooltipRef = null;
    };

    const handleDelete = async e => {
        closeTooltip();
        await conversation.leave();
        await conversation.delete();
    };

    const handleAllRead = async () => {
        closeTooltip();
        await conversation.setAllMessagesRead();
        // const unread = await conversation.getUnreadMessagesCount();
        await conversation.updateLastReadMessageIndex(conversation.channelState.lastReadMessageIndex);
    };

    const handleAllUnread = async () => {
        closeTooltip();
        await conversation.setAllMessagesUnread();
        const unread = await conversation.getUnreadMessagesCount();
        console.log({ unread, unread1, unread2 });
    };

    return (
        <>
            <SettingsButtonStyled
                ref={clickOutsideRef}
                id={tooltipID}
                data-tip
                onMouseEnter={() => ReactTooltip.hide()}
                data-for={tooltipID}
                data-event="click"
                data-place="right"
                type="button"
            >
                <ThreeDotIcon />
            </SettingsButtonStyled>

            <ReactTooltip
                ref={tooltipRef}
                globalEventOff="click"
                id={tooltipID}
                clickable
                className="tooltip"
                type="light"
                effect="solid"
            >
                <ButtonNoStyles type="button" onClick={handleAllRead}>
                    Mark as Read
                </ButtonNoStyles>
            </ReactTooltip>
        </>
    );
};
SettingsButton.propTypes = {
    conversation: PropTypes.any,
};
export default SettingsButton;
